"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchAnalyticsDomEvent = exports.createEventDomElement = void 0;
var _constants = require("./constants");
var _lodash = _interopRequireDefault(require("lodash.get"));
var _lodash2 = _interopRequireDefault(require("lodash.set"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var dispatchAnalyticsDomEvent = function dispatchAnalyticsDomEvent(_ref) {
  var name = _ref.name,
    data = _ref.data;
  if ((0, _lodash.default)(window, 'CustomEvent')) {
    var camelCasedEventName = name.replace(/-([a-z])/g, function (g) {
      return g[1].toUpperCase();
    });
    // Use camelCase as launch data element path doesn't support dash-case
    (0, _lodash2.default)(window, "digitalData.event.".concat(camelCasedEventName), _objectSpread({}, data));

    // eslint-disable-next-line no-undef
    var customEvent = new CustomEvent(name, {
      bubbles: true,
      detail: data
    });
    var _document = (0, _lodash.default)(window, 'document', null);
    if (!_document) {
      return;
    }
    var domElement = _document.getElementById(_constants.DTM_EVENTS_DOM_ELEMENT.toString());
    if (domElement !== null) {
      _document.getElementById(_constants.DTM_EVENTS_DOM_ELEMENT.toString()).dispatchEvent(customEvent);
    }
  }
};
exports.dispatchAnalyticsDomEvent = dispatchAnalyticsDomEvent;
var createEventDomElement = function createEventDomElement() {
  var domElement = window.document.getElementById(_constants.DTM_EVENTS_DOM_ELEMENT);
  if (domElement) return;
  var eventDomElement = window.document.createElement('div');
  eventDomElement.id = _constants.DTM_EVENTS_DOM_ELEMENT;
  window.document.body.appendChild(eventDomElement);
};
exports.createEventDomElement = createEventDomElement;